<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		:persistent="buttonIsLoading"
		@click:outside="handleDismiss"
		@keydown.esc="handleDismiss"
	>
		<v-card data-test="delete-build-dialog">
			<v-card-title class="dialog-header sgnl-subtitle-medium"> Delete Build? </v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<p class="sgnl-paragraph-m-regular sgnl-text-color-secondary">
					Would you like to permanently delete build
					<code
						class="sgnl-code-default"
						v-if="buildID != null"
						data-test="build-card-build-id-value"
						>{{ buildID }}</code
					>?
				</p>
				<v-alert
					:icon="false"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					<strong>This operation can not be undone.</strong>
				</v-alert>
				<v-alert
					v-if="showSupportMessage"
					:icon="false"
					border="start"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					{{ getSupportMessage }}
				</v-alert>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="handleDismiss"
				>
					Cancel
				</v-btn>
				<v-btn
					variant="flat"
					color="error"
					:loading="buttonIsLoading"
					@click="removeBuild"
					data-test="build-remove-button"
				>
					Delete Build
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { sdk } from "@/js/sdk";
import { useBuildsStore } from "@/stores/builds";

const SupportMessage = `Could not remove this item.\n If this issue persists, please contact Signaloid Support at\n developer-support@signaloid.com. `;

export default defineComponent({
	name: "BuildRemoveDialog",
	emits: ["update:showDialog", "remove-build-success", "close-remove-build-dialog"],
	data: () => ({
		buttonIsLoading: false,
		showSupportMessage: false,
	}),
	props: {
		showDialog: { type: Boolean, default: false },
		buildID: {
			type: String,
			default: null,
		},
	},
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
		getSupportMessage() {
			return SupportMessage;
		},
	},
	setup() {
		const buildsStore = useBuildsStore();
		return {
			buildsStore,
		};
	},
	methods: {
		async removeBuild() {
			this.buttonIsLoading = true;
			try {
				await sdk.builds.deleteOne(this.$props.buildID);

				this.buttonIsLoading = false;
				this.closeDialog();
				this.buildsStore.removeBuildByIdFromLocal(this.$props.buildID);
				this.$emit("remove-build-success");
			} catch {
				this.buttonIsLoading = false;
				this.showSupportMessage = true;
			}
		},
		handleDismiss() {
			if (this.buttonIsLoading) {
				return;
			}
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("close-remove-build-dialog");
		},
	},
});
</script>
